import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dismissable"
// Allows dismissing/removing an element from the DOM
export default class extends Controller {
  dismiss() {
    this.element.remove()
  }
}
